import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ErrorAlert = ({ error, onDismiss }) => {
  if (!error) return null;

  const getErrorConfig = (errorType) => {
    switch (errorType) {
      case 'invalid_credentials':
        return {
          title: 'Credenciales Incorrectas',
          message: 'El correo electrónico o la contraseña son incorrectos. Por favor, verifique sus datos e intente nuevamente.',
          icon: 'AlertCircle',
          suggestion: 'Credenciales de prueba: admin@everforce.com / admin123'
        };
      case 'network_error':
        return {
          title: 'Error de Conexión',
          message: 'No se pudo conectar con el servidor. Verifique su conexión a internet e intente nuevamente.',
          icon: 'Wifi',
          suggestion: 'Intente recargar la página o contacte al administrador del sistema'
        };
      case 'account_locked':
        return {
          title: 'Cuenta Bloqueada',
          message: 'Su cuenta ha sido bloqueada temporalmente por múltiples intentos fallidos.',
          icon: 'Lock',
          suggestion: 'Contacte al administrador del sistema para desbloquear su cuenta'
        };
      case 'session_expired':
        return {
          title: 'Sesión Expirada',
          message: 'Su sesión ha expirado por inactividad. Por favor, inicie sesión nuevamente.',
          icon: 'Clock',
          suggestion: 'Ingrese sus credenciales para continuar'
        };
      default:
        return {
          title: 'Error de Autenticación',
          message: error.message || 'Ha ocurrido un error inesperado. Por favor, intente nuevamente.',
          icon: 'AlertTriangle',
          suggestion: 'Si el problema persiste, contacte al soporte técnico'
        };
    }
  };

  const errorConfig = getErrorConfig(error.type);

  return (
    <div className="mb-6 p-4 bg-error-50 border border-error-100 rounded-lg animate-in slide-in-from-top-2">
      <div className="flex items-start space-x-3">
        <div className="flex-shrink-0">
          <Icon name={errorConfig.icon} size={20} className="text-error mt-0.5" />
        </div>
        
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-body-medium text-error mb-1">
            {errorConfig.title}
          </h3>
          <p className="text-sm text-error-600 mb-2">
            {errorConfig.message}
          </p>
          
          {errorConfig.suggestion && (
            <div className="mt-3 p-3 bg-error-100 rounded-md">
              <p className="text-xs text-error-700">
                <Icon name="Info" size={14} className="inline mr-1" />
                {errorConfig.suggestion}
              </p>
            </div>
          )}
        </div>
        
        <div className="flex-shrink-0">
          <Button
            variant="ghost"
            size="sm"
            onClick={onDismiss}
            iconName="X"
            iconSize={16}
            className="text-error hover:bg-error-100"
          />
        </div>
      </div>
    </div>
  );
};

export default ErrorAlert;